/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Cost
 */
export interface Cost {
    /**
     * 
     * @type {string}
     * @memberof Cost
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof Cost
     */
    unit: string;
    /**
     * 
     * @type {number}
     * @memberof Cost
     */
    value: number;
}

export function CostFromJSON(json: any): Cost {
    return CostFromJSONTyped(json, false);
}

export function CostFromJSONTyped(json: any, ignoreDiscriminator: boolean): Cost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currency': json['currency'],
        'unit': json['unit'],
        'value': json['value'],
    };
}

export function CostToJSON(value?: Cost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency': value.currency,
        'unit': value.unit,
        'value': value.value,
    };
}


